import React from 'react';
import styled from 'styled-components'

// Styled Components Section
const Label = styled.label`
    font-family: 'Montserrat-Regular';
    font-size: 1.1em;
    width: 270px;
    height: max-content;
    word-break: break-all;
    /* background-color: rebeccapurple; */
`
const InputText = styled.input`
    width: 270px;
    height: 40px;
    border-radius: 12px;
    border: 2px solid #10609A;
    margin: 5px 0 10px 0;
    padding-left: 10px;
    font-family: 'Montserrat-Regular';
    font-size: 17px;
    font-weight: 300;
`
const LabelFile = styled.label`
    border: dashed 2px #10609A;
    border-radius: 10px;
    padding: 0.5em 0.5em;
    margin-top: 0.6em;
    width: 270px;
    height: 53px;
    cursor: pointer;
    white-space: normal;
    font-family: 'Montserrat-Regular';
    font-size: 0.9em;
`
const InputFile = styled.input`
    opacity: 0;
`
const LabelRadio = styled.label`
    background-color: #e4e4e4;
	color: var(--grey-border);
	font-size: 15px;
    font-weight: 500;
	text-align: center;
	padding: 8px 16px;
	border: 2px solid #10609A;
    border-radius: 10px;
	transition: all 1s ease-in-out;
    &:hover{
        cursor: pointer;
    }
`
const InputRadio = styled.input`
    position: absolute;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	width: 1px;
	border: 0;
	overflow: hidden;
    &:checked + ${LabelRadio}{
        background-color: #2ecc71;
        box-shadow: none;
        color: #e4e4e4;
        font-weight: 500;
    }
`
const RadioContainer = styled.div`
    display:grid;
    grid-template-columns: 120px 120px;
    column-gap: 30px;
    align-items: center;
    justify-content: center;
	overflow: hidden;
    margin-top: 1em;
    font-family: 'Montserrat', sans-serif;
`
// const Select = styled.select`
//     width: 270px;
//     height: 40px;
//     border-radius: 12px;
//     border: 2px solid #10609A;
//     margin-bottom: 10px;
//     padding-left: 10px;
//     font-family: 'Montserrat', sans-serif;
//     font-size: 17px;
//     font-weight: 300;

// `
const DataList = styled.datalist`

`
const Option = styled.option`

`
const FormGroup = styled.div`
    display: grid;
    grid-auto-flow: row;
    padding: 5px;
`
const FormContainer = styled.form`
    display: grid;
    justify-items: center;
    align-items: center;
    grid-template-columns: 1fr 1fr 1fr;
    width: 1200px;
    margin:0 auto;
    padding: 2em 0;
`
const Submit = styled.input`
    background-color:#2ecc71;
    border: solid 2px #3c434b;
    border-radius: 10px;
    margin: 15 0px;
    padding: 15px;
    height: 55px;
    color: #ecf0f1;
    font-family: 'Montserrat', sans-serif;
    font-weight: 800;
    font-size: 20px;
    cursor: pointer;

`
export const FormRegister = (props) => {
    return (
        <FormContainer onSubmit={props.onSubmit} encType='multipart/form-data'>
            <FormGroup> {/*Nombres*/}
                <Label htmlFor='nombres'>Nombre(s)</Label>
                <InputText 
                    type='text'
                    name='nombres'
                    defaultValue={props.defaultName}
                    onChange={props.onChangeName}
                    required/>
            </FormGroup>
            <FormGroup> {/*Apellidos*/}
                <Label htmlFor='apellidos'>Apellidos</Label>
                <InputText 
                    type='text'
                    name='apellidos'
                    defaultValue={props.defaultLastname}
                    onChange={props.onChangeLastname}
                    required/>
            </FormGroup>
            <FormGroup> {/*Documento de identidad*/}
                <Label htmlFor='documento_de_identidad'>Documento de Identidad</Label>
                <InputText 
                    type='number'
                    name='documento_de_identidad'
                    defaultValue={props.defaultIdDocument}
                    onChange={props.onChangeIdDocument}
                    required/>
            </FormGroup>
            <FormGroup> {/*Edad*/}
                <Label htmlFor='edad'>Edad</Label>
                <InputText 
                    type='number'
                    name='edad'
                    defaultValue={props.defaultAge}
                    onChange={props.onChangeAge}
                    required/>
            </FormGroup>
            <FormGroup> {/*Dirección*/}
                <Label htmlFor='direccion'>Dirección</Label>
                <InputText 
                    type='text'
                    name='direccion'
                    defaultValue={props.defaultAddress}
                    onChange={props.onChangeAddress}
                    required/>
            </FormGroup>
            <FormGroup> {/*Correo Electrónico*/}
                <Label htmlFor='correo_electronico'>Correo Electrónico</Label>
                <InputText 
                    type='email'
                    name='correo_electronico'
                    defaultValue={props.defaultEmail}
                    onChange={props.onChangeEmail}
                    required/>
            </FormGroup>
            <FormGroup> {/*Télefono Móvil*/}
                <Label htmlFor='celular'>Télefono Móvil</Label>
                <InputText 
                    type='text'
                    name='celular'
                    defaultValue={props.defaultPhone}
                    onChange={props.onChangePhone}
                    required/>
            </FormGroup>
            <FormGroup> {/*Barrio*/}
                <Label htmlFor='barrio'>Barrio</Label>
                <InputText 
                    type='text'
                    name='barrio'
                    defaultValue={props.defaultNeighborhood}
                    onChange={props.onChangeNeighborhood}
                    required/>
            </FormGroup>
            <FormGroup> {/*Discapacidad*/}
                <Label htmlFor='discapacidad'>¿Posee alguna discapacidad?</Label>
                <InputText 
                    name='discapacidad'
                    onChange={props.onChangeDisability}
                    type="text" 
                    list='discapacidad' 
                    required/>
                <DataList id ='discapacidad'>
                    <Option value='Si, ¿Cuál?'/>
                    <Option value='No'/>
                </DataList>
            </FormGroup>
            <FormGroup> {/*Recibo*/}
                <Label htmlFor='recibo'>Adjunte</Label>
                <LabelFile htmlFor='image-file'>
                    {props.fileName}
                </LabelFile>
                <InputFile 
                    type='file'
                    id='image-file'
                    name='recibo' 
                    onChange={props.onChangeImage}
                    accept='image/x-png,image/gif,image/jpeg'
                    max-file-size="3072"
                    required/>
            </FormGroup>
            <FormGroup> {/*Aceptación de Terminos*/}
                <Label>¿Acepta el manejo de datos?</Label>
                <RadioContainer>
                    <InputRadio 
                        type='radio' 
                        name='terminosCondiciones' 
                        id='radioSí'
                        value='Sí' 
                        onChange={props.OnChangeTermns} required/>
                    <LabelRadio htmlFor='radioSí'>Sí</LabelRadio>
                    <InputRadio 
                        type='radio'
                        name='terminosCondiciones'
                        id='radioNo'
                        value='No' 
                        onChange={props.OnChangeTermns} />
                    <LabelRadio htmlFor='radioNo'>No</LabelRadio>
                </RadioContainer>
            </FormGroup>
            <FormGroup> {/*Enviar*/}
                <Submit 
                    type='submit'
                    value='Enviar Pre-Registro'/>
            </FormGroup>
        </FormContainer>
    )
}
